import { render, staticRenderFns } from "./PostSwipe.vue?vue&type=template&id=3e6db3c1"
import script from "./PostSwipe.vue?vue&type=script&lang=js"
export * from "./PostSwipe.vue?vue&type=script&lang=js"
import style0 from "./PostSwipe.vue?vue&type=style&index=0&id=3e6db3c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports